export default "__VITE_ASSET__Dl5dibip__"